var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m168.396 384.36-108.446 75.721 4.612 33.799c1.339 9.848 8.152 18.09 18.089 18.09h123.084l25.825-95.893z",
    fill: "#eb5468",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m339.766 155.622-159.053-16.032-162.237 16.032 23.147 169.888 183.301-13.27 108.356-109.014z",
    fill: "#eb5468",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m194.458 274.246-152.835 51.264 18.327 134.571 129.242-44.778c-2.231-3.57-3.481-7.765-3.481-12.258 0-12.883 10.532-23.445 23.444-23.445h4.016c-5.445-6.605-8.955-16.096-8.955-28.801h-11.454c-6.635 0-12.049-5.415-12.049-12.05v-10.562c0-20.499 4.998-38.47 13.745-53.941z",
    fill: "#f9f7f8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m167.711 112.659h-155.096c-6.932 0-12.615 5.683-12.615 12.645v17.703c0 6.932 5.683 12.615 12.615 12.615h5.861 321.29 5.861c6.932 0 12.615-5.683 12.615-12.615v-17.703c0-6.962-5.683-12.645-12.615-12.645h-143.314z",
    fill: "#f9f7f8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m260.775.581-80.122 20.886c-7.735 2.023-12.942 8.777-12.942 16.751v74.441h34.601v-61.082l67.209-17.495c9.193-2.41 14.757-11.901 12.377-21.095-2.409-9.223-11.9-14.787-21.123-12.406z",
    fill: "#375e7d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m208.531 461.926 142.303 6.158 121.09-6.158h12.258v-35.406l-137.84-23.475-137.811 23.475z",
    fill: "#ffe07d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m209.156 379.6c-12.912 0-23.444 10.562-23.444 23.445 0 4.493 1.25 8.688 3.481 12.258 4.017 6.546 11.187 10.979 19.339 11.217h.625 274.402.625c12.615-.357 22.82-10.77 22.82-23.475 0-12.883-10.562-23.445-23.444-23.445-93.572 0-180.864 0-274.404 0z",
    fill: "#ce775f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m488.496 350.799-144.624-32.133-139.655 32.133c0 12.704 3.511 22.195 8.955 28.801 12.823 15.561 36.446 14.995 50.191 2.678 2.231-1.993 3.005-2.231 5.117-.03 6.992 7.349 15.62 11.008 24.248 11.008s17.256-3.66 24.248-11.008c2.261-2.023 3.035-2.231 5.117-.03 6.992 7.349 15.62 11.008 24.248 11.008 8.658 0 17.286-3.66 24.278-11.008 2.083-2.202 2.856-1.993 5.088.03 6.992 7.349 15.65 11.008 24.278 11.008s17.256-3.66 24.248-11.008c2.112-2.202 2.856-1.964 5.117.03 13.745 12.318 37.368 12.883 50.191-2.678 5.444-6.605 8.955-16.096 8.955-28.801z",
    fill: "#a7e9a6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m333.28 203.226c-57.986 3.094-113.801 26.777-138.822 71.02-8.747 15.471-13.745 33.442-13.745 53.942v10.562c0 6.635 5.415 12.05 12.049 12.05h11.454 284.279 11.454c6.635 0 12.049-5.415 12.049-12.05v-10.562c.002-87.92-91.783-129.603-178.718-124.962z",
    fill: "#ffbc85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m329.026 203.494c76.671 5.415 148.313 47.009 148.313 124.693v10.562c0 3.422-1.458 6.546-3.749 8.717-2.172 2.053-5.088 3.332-8.271 3.332h23.177 11.454c6.635 0 12.049-5.415 12.049-12.05v-10.562c0-87.919-91.785-129.603-178.72-124.961-1.427.09-2.825.18-4.253.269z",
    fill: "#f5a96c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m449.134 426.52h34.423.625c12.615-.357 22.82-10.77 22.82-23.475 0-12.883-10.562-23.445-23.444-23.445h-4.017c-3.481 4.225-7.765 7.26-12.436 9.194 3.035 3.957 4.85 8.926 4.85 14.252 0 8.152-4.195 15.382-10.562 19.577-3.541 2.35-7.736 3.778-12.259 3.897z",
    fill: "#be694f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m449.134 461.926h22.79 12.258v-35.406h-.625-34.423z",
    fill: "#ffd064",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m435.359 386.592c9.521 5.415 21.54 6.456 31.745 2.202 4.671-1.934 8.955-4.969 12.436-9.194 5.445-6.605 8.955-16.096 8.955-28.801h-23.177-12.942c0 12.704-3.511 22.195-8.955 28.801-2.349 2.856-5.087 5.207-8.062 6.992z",
    fill: "#7fdbae",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m203.354 187.219c43.051 1.934 43.795 9.104 51.649 34.454 22.314-10.265 47.871-16.334 74.023-18.179 1.428-.089 2.826-.179 4.255-.268l6.486-47.604h-153.58-167.711l4.314 31.597z",
    fill: "#e5384f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m282.554 155.622h57.213 5.861c6.932 0 12.615-5.683 12.615-12.615v-17.703c0-6.962-5.683-12.645-12.615-12.645h-63.074c6.932 0 12.615 5.683 12.615 12.645v17.703c-.001 6.932-5.683 12.615-12.615 12.615z",
    fill: "#dddaec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m202.313 51.577 67.209-17.495c9.193-2.41 14.757-11.901 12.377-21.095l-82.145 20.827c-13.983 3.541-10.978 14.906-10.978 29.991v48.854h13.537z",
    fill: "#2b4d66",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m484.182 461.926h-275.651-22.314c-3.035 0-5.504 2.469-5.504 5.475v19.547c0 13.746 11.276 25.022 25.021 25.022h281.244c13.745 0 25.021-11.276 25.021-25.022v-19.548c0-3.005-2.469-5.475-5.504-5.475h-22.313z",
    fill: "#ffbc85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m477.339 486.948c0 13.746-11.246 25.022-25.021 25.022h34.661c13.745 0 25.021-11.276 25.021-25.022v-19.548c0-3.005-2.469-5.475-5.504-5.475h-22.314-12.258c1.369 0 2.618.536 3.57 1.398 1.131 1.012 1.845 2.469 1.845 4.076z",
    fill: "#f5a96c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m467.848 319.966c-1.977 0-3.955-.755-5.463-2.263-3.018-3.018-3.047-7.94-.03-10.957 3.018-3.018 7.88-3.046 10.897-.03l.059.059c3.018 3.018 3.018 7.909 0 10.928-1.508 1.508-3.486 2.263-5.463 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m419.264 319.966c-1.967 0-3.934-.745-5.44-2.24-3.03-3.004-3.081-7.926-.076-10.956 3.003-3.031 7.866-3.081 10.896-.075l.06.059c3.03 3.004 3.051 7.896.046 10.927-1.511 1.522-3.499 2.285-5.486 2.285z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m370.679 319.966c-1.977 0-3.955-.755-5.463-2.263-3.018-3.018-3.047-7.94-.03-10.957 3.018-3.018 7.88-3.046 10.897-.03l.059.059c3.018 3.018 3.018 7.909 0 10.928-1.509 1.508-3.486 2.263-5.463 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322.094 319.966c-1.977 0-3.955-.755-5.463-2.263-3.018-3.018-3.047-7.94-.03-10.957 3.018-3.018 7.88-3.046 10.897-.03l.059.059c3.018 3.018 3.018 7.909 0 10.928-1.509 1.508-3.486 2.263-5.463 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m273.509 319.966c-1.977 0-3.955-.755-5.463-2.263-3.018-3.018-3.047-7.94-.03-10.957 3.018-3.018 7.88-3.046 10.897-.03l.059.059c3.018 3.018 3.018 7.909 0 10.928-1.508 1.508-3.486 2.263-5.463 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m224.924 319.966c-1.977 0-3.955-.755-5.463-2.263-3.018-3.018-3.047-7.94-.03-10.957 3.018-3.018 7.88-3.046 10.897-.03l.059.059c3.018 3.018 3.018 7.909 0 10.928-1.508 1.508-3.486 2.263-5.463 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m443.578 283.044c-2.493 0-4.941-1.205-6.43-3.434l-.06-.09c-2.372-3.547-1.419-8.345 2.129-10.717 3.547-2.37 8.346-1.418 10.717 2.13l.06.09c2.372 3.547 1.419 8.345-2.129 10.717-1.319.882-2.811 1.304-4.287 1.304z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m394.986 283.043c-1.977 0-3.955-.755-5.463-2.263l-.09-.09c-3.018-3.018-3.018-7.909 0-10.928 3.017-3.016 7.909-3.016 10.927 0l.09.09c3.018 3.018 3.018 7.909 0 10.928-1.509 1.509-3.487 2.263-5.464 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346.312 282.954c-1.977 0-3.955-.755-5.463-2.263-3.018-3.018-3.047-7.94-.03-10.957s7.88-3.047 10.897-.03l.059.059c3.018 3.018 3.018 7.909 0 10.928-1.508 1.508-3.486 2.263-5.463 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m297.727 282.954c-1.977 0-3.955-.755-5.463-2.263-3.018-3.018-3.047-7.94-.03-10.957 3.018-3.017 7.88-3.047 10.897-.03l.059.059c3.018 3.018 3.018 7.909 0 10.928-1.508 1.508-3.486 2.263-5.463 2.263z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m249.09 282.895c-2.504 0-4.96-1.215-6.447-3.459l-.059-.09c-2.358-3.556-1.386-8.351 2.171-10.708 3.557-2.36 8.352-1.385 10.709 2.171l.059.09c2.358 3.556 1.386 8.351-2.171 10.708-1.314.872-2.797 1.288-4.262 1.288z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m370.552 246.121c-1.489 0-2.994-.43-4.32-1.327-3.535-2.39-4.463-7.193-2.073-10.728l.06-.089c2.39-3.535 7.194-4.465 10.728-2.072 3.535 2.39 4.463 7.193 2.073 10.728l-.06.089c-1.493 2.208-3.929 3.399-6.408 3.399z",
    fill: "#fed1a3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.968 246.121c-1.479 0-2.974-.425-4.296-1.31-3.544-2.376-4.491-7.176-2.115-10.72l.059-.089c2.376-3.544 7.175-4.489 10.72-2.115 3.544 2.376 4.491 7.176 2.115 10.72l-.059.089c-1.49 2.224-3.935 3.425-6.424 3.425z",
    fill: "#fed1a3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastFood);
export default __webpack_public_path__ + "static/media/fast-food.2516323bbb281c56ca490aba190385d9.svg";
export { ForwardRef as ReactComponent };